import { Controller } from "@hotwired/stimulus"

// Sternebewertung: Anzeige sofort aus HTML, Klicks senden an /rate und aktualisieren die Sterne.
// Ersetzt jQuery Raty/ratyrate; Bewertungen sind beim Laden bereits sichtbar.
export default class extends Controller {
  static values = {
    rateUrl: String,
    dimension: String,
    rateableId: String,
    rateableClass: String,
    readOnly: String,
    cancelHint: String,
    initialScore: String,
    cancel: String
  }

  static targets = ["star", "cancel"]

  connect() {
    this.score = parseInt(this.initialScoreValue || "0", 10) || 0
    this.updateStarsDisplay()
  }

  setScore(event) {
    if (this.readOnlyValue === "true") return
    const starEl = event.currentTarget
    const score = parseInt(starEl.dataset.score, 10) || 0
    this.score = score
    this.updateStarsDisplay()
    this.postScore(score)
  }

  cancel(event) {
    if (event) event.preventDefault()
    if (this.readOnlyValue === "true") return
    this.score = 0
    this.updateStarsDisplay()
    this.postScore(0)
  }

  updateStarsDisplay() {
    if (!this.hasStarTarget) return
    this.starTargets.forEach((starEl, index) => {
      const scoreVal = parseInt(starEl.dataset.score, 10) || (index + 1)
      const filled = scoreVal <= this.score
      const icon = starEl.querySelector("i")
      if (icon) {
        icon.classList.remove("fa-star", "fa-star-half-alt", "far", "fas", "text-yellow-400", "text-gray-300")
        icon.classList.add(filled ? "fas" : "far", "fa-star", filled ? "text-yellow-400" : "text-gray-300")
      }
    })
  }

  async postScore(score) {
    const url = this.rateUrlValue || "/rate"
    const body = new URLSearchParams({
      score: String(score),
      dimension: this.dimensionValue,
      id: this.rateableIdValue,
      klass: this.rateableClassValue
    })
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken || "",
          Accept: "application/json"
        },
        body: body.toString()
      })
      if (!response.ok) {
        console.warn("Star rating: request failed", response.status)
      }
    } catch (e) {
      console.warn("Star rating: request error", e)
    }
  }
}
